const insertScript = (element, src, id, async = false, defer = true, attributes = {}) => {
  if (document.querySelector(`script[src^="${src}"]`)) return;

  const script = Object.assign(document.createElement("script"), {
    src,
    id,
    async: async && !defer,
    defer,
  });

  Object.keys(attributes).forEach((key) => {
    script.setAttribute(key, attributes[key]);
  });

  element.appendChild(script);
};

export default insertScript;
